import { frontendURL } from '../../../helper/URLHelper';
import IframeAppView from './IframeAppView.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/iframe-apps/:iframeAppId'),
    name: 'iframe_app_view',
    component: IframeAppView,
    meta: {
      permissions: ['administrator', 'agent', 'custom_role'],
    },
    props: route => ({
      iframeAppId: route.params.iframeAppId,
    }),
  },
];
